import { render, staticRenderFns } from "./PreventivasDetalleGrid.vue?vue&type=template&id=0a0ea547&"
import script from "./PreventivasDetalleGrid.vue?vue&type=script&lang=ts&"
export * from "./PreventivasDetalleGrid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0a0ea547', component.options)
    } else {
      api.reload('0a0ea547', component.options)
    }
    module.hot.accept("./PreventivasDetalleGrid.vue?vue&type=template&id=0a0ea547&", function () {
      api.rerender('0a0ea547', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Inicio/DetalleVehiculo/PreventivasDetalleGrid.vue"
export default component.exports